export default {
  en: {
    'components.registrations.filing-types-list-item.delete-confirmation.message':
      'Please note, by deleting this filing type you will remove any existing Due Filing opportunities for this country.',
    'components.registrations.filing-types-list-item.auto.label': 'Required',
    'components.registrations.filing-types-list-item.auto.message':
      'Statutory required filing, based on your other filing types.',
  },
};
